import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoClienteSituacaoMultiSelectComponent } from './novo-cliente-situacao-multi-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoClienteSituacaoMultiSelectComponent],
  exports: [NovoClienteSituacaoMultiSelectComponent]
})
export class NovoClienteSituacaoMultiSelectModule {}
